var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cdb-rdb" },
    [
      _c(
        "v-alert",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showSuccess,
              expression: "showSuccess"
            }
          ],
          staticClass: "alert",
          attrs: {
            transition: "scroll-x-reverse-transition",
            type: "success",
            border: "left",
            elevation: "3"
          }
        },
        [_vm._v(" " + _vm._s(_vm.message) + " ")]
      ),
      _c(
        "v-row",
        { staticClass: "flex-column", attrs: { align: "start" } },
        [
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-filelds" }, [
              _vm._v("Nome do ativo")
            ])
          ]),
          _c(
            "v-col",
            [
              _c("v-text-field", {
                staticClass: "select",
                attrs: {
                  loading: _vm.loading,
                  placeholder: "Insira o nome do ativo",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  rules: [
                    function(v) {
                      return !!v || "Campo obrigatório"
                    },
                    function(v) {
                      return (
                        (v && v.length > 3) ||
                        "O codigo deve conter de 4 a 19 caracteres."
                      )
                    },
                    function(v) {
                      return (
                        (v && v.length < 20) ||
                        "O codigo deve conter de 4 a 19 caracteres."
                      )
                    },
                    function(v) {
                      return (
                        !this$1.usersActive.some(function(a) {
                          return (
                            a.code &&
                            a.code.trim().toLowerCase() ===
                              (v || "").trim().toLowerCase()
                          )
                        }) || "Já existe um ativo com este nome."
                      )
                    }
                  ]
                },
                on: { keyup: _vm.saveCodigo },
                model: {
                  value: _vm.codigo,
                  callback: function($$v) {
                    _vm.codigo = $$v
                  },
                  expression: "codigo"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-filelds" }, [
              _vm._v("Descrição do ativo")
            ])
          ]),
          _c(
            "v-col",
            [
              _c("v-text-field", {
                staticClass: "select",
                attrs: {
                  loading: _vm.loading,
                  placeholder: "Insira a descrição do ativo",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  rules: [
                    function(v) {
                      return !!v || "Campo obrigatório"
                    },
                    function(v) {
                      return (
                        (v && v.length > 3) ||
                        "O codigo deve conter de 4 a 100 caracteres."
                      )
                    },
                    function(v) {
                      return (
                        (v && v.length < 101) ||
                        "O codigo deve conter de 4 a 100 caracteres."
                      )
                    }
                  ]
                },
                on: { keyup: _vm.saveDescription },
                model: {
                  value: _vm.description,
                  callback: function($$v) {
                    _vm.description = $$v
                  },
                  expression: "description"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-filelds" }, [_vm._v("Emissor")])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  items: _vm.entityCreditRisk,
                  loading: _vm.loading,
                  "item-text": "fullName",
                  "item-value": "entityId",
                  placeholder: "Insira o Emissor",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  rounded: "",
                  dense: "",
                  clearable: "",
                  attach: "",
                  filter: _vm.filterObject,
                  rules: [
                    function(v) {
                      return v != null || "Campo obrigatório"
                    }
                  ]
                },
                on: { change: _vm.saveEmissor },
                model: {
                  value: _vm.emissor,
                  callback: function($$v) {
                    _vm.emissor = $$v
                  },
                  expression: "emissor"
                }
              })
            ],
            1
          ),
          _c("v-col", { staticClass: "d-flex flex-column align-left py-0" }, [
            _c("span", { staticClass: "text-filelds" }, [_vm._v("Custodiante")])
          ]),
          _c(
            "v-col",
            [
              _c("v-autocomplete", {
                staticClass: "select",
                attrs: {
                  items: _vm.custodians,
                  loading: _vm.loading,
                  "item-text": "fullName",
                  "item-value": "entityId",
                  placeholder: "Insira o custodiante",
                  color: "secondary",
                  required: "",
                  outlined: "",
                  dense: "",
                  rounded: "",
                  height: "10",
                  clearable: "",
                  attach: "",
                  filter: _vm.filterObject,
                  rules: [
                    function(v) {
                      return v != null || "Campo obrigatório"
                    }
                  ]
                },
                on: { change: _vm.saveCustodiante },
                model: {
                  value: _vm.custodiante,
                  callback: function($$v) {
                    _vm.custodiante = $$v
                  },
                  expression: "custodiante"
                }
              })
            ],
            1
          ),
          _c("v-row", { staticClass: "d-flex flex-wrap flexx" }, [
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Estratégia")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "column", attrs: { cols: "1" } },
                  [
                    _c("v-autocomplete", {
                      staticClass: "select",
                      attrs: {
                        items: _vm.estrategias,
                        loading: _vm.loading,
                        "item-text": "descricao",
                        "item-value": "idEstrategia",
                        placeholder: "Estrategia",
                        color: "secondary",
                        required: "",
                        outlined: "",
                        "background-color": "#f6f6f6",
                        "return-object": true,
                        rounded: "",
                        dense: "",
                        attach: "",
                        rules: [
                          function(v) {
                            return !!v || "Campo obrigatório"
                          }
                        ]
                      },
                      on: { change: _vm.saveEstrategia },
                      model: {
                        value: _vm.estrategia,
                        callback: function($$v) {
                          _vm.estrategia = $$v
                        },
                        expression: "estrategia"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Indexador")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "column", attrs: { cols: "1" } },
                  [
                    _c("v-autocomplete", {
                      staticClass: "select",
                      attrs: {
                        items: _vm.indexadores,
                        loading: _vm.loading,
                        "item-text": "descricao",
                        "item-value": "idIndexador",
                        placeholder: "Indexador",
                        color: "secondary",
                        "background-color": "#f6f6f6",
                        "return-object": true,
                        outlined: "",
                        rounded: "",
                        dense: "",
                        attach: "",
                        rules: [
                          function(v) {
                            return !!v || "Campo obrigatório"
                          }
                        ]
                      },
                      on: { change: _vm.saveIndexador },
                      model: {
                        value: _vm.indexador,
                        callback: function($$v) {
                          _vm.indexador = $$v
                        },
                        expression: "indexador"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [_c("span", { staticClass: "text-filelds" }, [_vm._v("FGC")])]
                ),
                _c(
                  "v-col",
                  { staticClass: "column", attrs: { cols: "1" } },
                  [
                    _c("v-autocomplete", {
                      staticClass: "select",
                      attrs: {
                        attach: "",
                        items: _vm.fgcOptions,
                        loading: _vm.loading,
                        "item-text": "descricao",
                        "item-value": "id",
                        placeholder: "FGC",
                        color: "secondary",
                        "background-color": "#f6f6f6",
                        "return-object": true,
                        outlined: "",
                        rounded: "",
                        dense: "",
                        rules: [
                          function(v) {
                            return v != null || "Campo obrigatório"
                          }
                        ]
                      },
                      on: { change: _vm.saveFgc },
                      model: {
                        value: _vm.fgc,
                        callback: function($$v) {
                          _vm.fgc = $$v
                        },
                        expression: "fgc"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Data Aplicação ")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0 flex-grow-0 flex-shrink-1",
                    staticStyle: { padding: "0" }
                  },
                  [_c("DatePiker", { on: { change: _vm.saveDataAplicacao } })],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Data Vencimento ")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [_c("DatePiker", { on: { change: _vm.saveVencimento } })],
                  1
                )
              ],
              1
            ),
            _vm.estrategia.idEstrategia !== 2
              ? _c(
                  "div",
                  { staticClass: "bloco" },
                  [
                    _c(
                      "v-col",
                      { staticClass: "d-flex flex-column align-left py-0" },
                      [
                        _c("span", { staticClass: "text-filelds" }, [
                          _vm._v(
                            _vm._s(
                              _vm.indice.rateFeesDescription
                                ? _vm.indice.rateFeesDescription
                                : "Taxa"
                            )
                          )
                        ])
                      ]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "py-0", staticStyle: { padding: "0" } },
                      [_c("ValorMonetario", { on: { change: _vm.saveTaxa } })],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Valor Aplicação(R$)")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      on: { change: _vm.saveValorAplicacao }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Tipo Remuneração")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "column", attrs: { cols: "1" } },
                  [
                    _c("v-autocomplete", {
                      staticClass: "select",
                      attrs: {
                        attach: "",
                        items: _vm.tiposRemuneracao,
                        loading: _vm.loading,
                        "item-text": "descricao",
                        "item-value": "idTremuneracao",
                        placeholder: "Tipo Remuneração",
                        color: "secondary",
                        "background-color": "#f6f6f6",
                        "return-object": true,
                        outlined: "",
                        rounded: "",
                        dense: "",
                        rules: [
                          function(v) {
                            return !!v || "Campo obrigatório"
                          }
                        ]
                      },
                      on: { change: _vm.saveRemuneracao },
                      model: {
                        value: _vm.remuneracao,
                        callback: function($$v) {
                          _vm.remuneracao = $$v
                        },
                        expression: "remuneracao"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm.estrategia.idEstrategia === 2
              ? _c(
                  "div",
                  { staticClass: "bloco" },
                  [
                    _c(
                      "v-col",
                      { staticClass: "d-flex flex-column align-left py-0" },
                      [
                        _c("span", { staticClass: "text-filelds" }, [
                          _vm._v("Percentual do Indexador")
                        ])
                      ]
                    ),
                    _c(
                      "v-col",
                      { staticClass: "py-0", staticStyle: { padding: "0" } },
                      [
                        _c("ValorMonetario", {
                          on: { change: _vm.savePercentual }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Liquidez")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  [
                    _c("v-select", {
                      staticClass: "select",
                      attrs: {
                        items: _vm.liquidezOptions,
                        "item-text": "name",
                        "item-value": "value",
                        placeholder: "Selecione o tipo de liquidez",
                        color: "secondary",
                        required: "",
                        outlined: "",
                        rounded: "",
                        dense: "",
                        height: "0",
                        attach: "",
                        rules: [
                          function(v) {
                            return v != null || "Campo obrigatório"
                          }
                        ]
                      },
                      on: { change: _vm.saveLiquidez },
                      model: {
                        value: _vm.liquidez,
                        callback: function($$v) {
                          _vm.liquidez = $$v
                        },
                        expression: "liquidez"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }